"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adal_angular_1 = __importDefault(require("adal-angular"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var _a = process.env, REACT_APP_AUTH_INSTANCE = _a.REACT_APP_AUTH_INSTANCE, REACT_APP_AUTH_TENANT = _a.REACT_APP_AUTH_TENANT, REACT_APP_AUTH_MULTITENANT = _a.REACT_APP_AUTH_MULTITENANT, REACT_APP_AUTH_CLIENT_ID = _a.REACT_APP_AUTH_CLIENT_ID, REACT_APP_AUTH_RESOURCE_ID = _a.REACT_APP_AUTH_RESOURCE_ID;
var isMultitenant = REACT_APP_AUTH_MULTITENANT &&
    REACT_APP_AUTH_MULTITENANT.toString().toLowerCase() === 'true';
// IE Polyfill for setting a window location origin
// from Modernizr
if (!window.location.origin) {
    var newWindowLocation = __assign({}, window.location);
    newWindowLocation.origin =
        window.location.protocol +
            "//" +
            window.location.hostname +
            (window.location.port ? ":" + window.location.port : "");
    window.location = newWindowLocation;
}
if (window.location.pathname !== "/" && !js_cookie_1.default.get("redirect")) {
    js_cookie_1.default.set("redirect", window.location.pathname + window.location.search);
}
exports.REDIRECT_URL = "/signin";
var adalAuthContext = new adal_angular_1.default({
    instance: REACT_APP_AUTH_INSTANCE,
    tenant: isMultitenant ? 'common' : REACT_APP_AUTH_TENANT,
    clientId: REACT_APP_AUTH_CLIENT_ID || "",
    postLogoutRedirectUri: window.location.origin,
    redirectUri: "" + window.location.origin + exports.REDIRECT_URL,
    navigateToLoginRequestUrl: false
});
var EVENT_ADAL_ACCESS_TOKEN_ERROR = "eventAdalAccessTokenError";
exports.BASE_API_HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json"
};
var ADAL_ERROR_TOKEN = "adal.error";
var ADAL_ERROR_DESCRIPTION = "adal.error.description";
var ADAL_LOGIN_ERRORS = [
    "login required",
    "login_required",
    "Token Renewal Failed",
    "interaction_required"
];
adalAuthContext.handleWindowCallback();
exports.acquireToken = function (requireDispatch) {
    if (requireDispatch === void 0) { requireDispatch = true; }
    return new Promise(function (resolve, reject) {
        adalAuthContext.acquireToken(REACT_APP_AUTH_RESOURCE_ID || "", function (error, token, errorType) {
            if (error) {
                if (requireDispatch) {
                    var accessTokenErrorEvent = new CustomEvent(EVENT_ADAL_ACCESS_TOKEN_ERROR, {
                        detail: {
                            error: error,
                            errorType: errorType
                        }
                    });
                    window.dispatchEvent(accessTokenErrorEvent);
                }
                return reject({ error: error, token: token, errorType: errorType });
            }
            return resolve(token);
        });
    });
};
var initialState = {
    user: null,
    token: null,
    error: null,
    errorDescription: null,
    fetchAuthorizationToken: function () { },
    logout: function () {
        adalAuthContext.logOut();
    }
};
var authenticationContext = react_1.default.createContext(initialState);
exports.ApAuthenticationContextConsumer = authenticationContext.Consumer;
var ApAuthenticationContextProvider = /** @class */ (function (_super) {
    __extends(ApAuthenticationContextProvider, _super);
    function ApAuthenticationContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            adalAuthContext.login();
        };
        _this.handleAccessTokenError = function (event) {
            var _a = event.detail, message = _a.message, errorType = _a.errorType;
            _this.setState({
                error: errorType,
                errorDescription: message
            });
        };
        _this.state = __assign({}, initialState, { fetchAuthorizationToken: function () { return __awaiter(_this, void 0, void 0, function () {
                var token, oldToken, error_1, errorType, message;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, exports.acquireToken(false)];
                        case 1:
                            token = _a.sent();
                            oldToken = this.state.token;
                            if (oldToken !== token) {
                                this.setState({ token: token });
                            }
                            return [2 /*return*/, token];
                        case 2:
                            error_1 = _a.sent();
                            errorType = error_1.errorType, message = error_1.message;
                            this.setState({
                                error: errorType,
                                errorDescription: message
                            });
                            throw error_1;
                        case 3: return [2 /*return*/];
                    }
                });
            }); } });
        return _this;
    }
    ApAuthenticationContextProvider.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error, errorDescription, user, resource, token, e_1, errorType, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        error = sessionStorage.getItem(ADAL_ERROR_TOKEN);
                        errorDescription = sessionStorage.getItem(ADAL_ERROR_DESCRIPTION);
                        user = adalAuthContext.getCachedUser();
                        resource = REACT_APP_AUTH_CLIENT_ID || "";
                        token = adalAuthContext.getCachedToken(resource);
                        window.addEventListener(EVENT_ADAL_ACCESS_TOKEN_ERROR, this.handleAccessTokenError);
                        if (user && token) {
                            this.setState({ user: user, token: token });
                            return [2 /*return*/];
                        }
                        if (error) {
                            this.setState({ error: error, errorDescription: errorDescription });
                            return [2 /*return*/];
                        }
                        if (!user) {
                            adalAuthContext.login();
                            return [2 /*return*/];
                        }
                        if (!!token) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, exports.acquireToken(false)];
                    case 2:
                        token = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        errorType = e_1.errorType, message = e_1.message;
                        this.setState({
                            error: errorType,
                            errorDescription: message
                        });
                        throw e_1;
                    case 4:
                        this.setState({
                            user: user,
                            token: token,
                            error: null,
                            errorDescription: null
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ApAuthenticationContextProvider.prototype.componentWillUnmount = function () {
        window.removeEventListener(EVENT_ADAL_ACCESS_TOKEN_ERROR, this.handleAccessTokenError);
    };
    ApAuthenticationContextProvider.prototype.render = function () {
        var _a = this.state, user = _a.user, token = _a.token, error = _a.error, errorDescription = _a.errorDescription;
        var _b = this.props, children = _b.children, errorComponent = _b.errorComponent;
        if (error) {
            console.log(user, token, error, errorDescription);
            if (ADAL_LOGIN_ERRORS.includes(error)) {
                adalAuthContext.login();
                return null;
            }
            else {
                return errorComponent({
                    errorType: error,
                    errorDescription: errorDescription,
                    onClick: this.handleClick
                });
            }
        }
        if (!user || !token)
            return null;
        return (react_1.default.createElement(authenticationContext.Provider, { value: this.state }, children));
    };
    return ApAuthenticationContextProvider;
}(react_1.default.Component));
exports.ApAuthenticationContextProvider = ApAuthenticationContextProvider;
//# sourceMappingURL=ApAuthenticationContext.js.map